import { Link } from "react-router-dom";
import { logoImage } from "@/constants/nossaData";

export const LogoMark = ({ compact = false, location = "header" }) => (
  <Link to="/" className="brand-mark" data-testid={`${location}-brand-logo-link`} aria-label="Ir al inicio de Nossa">
    <img className="brand-logo-image" src={logoImage} alt="Logo Nossa" data-testid={`${location}-brand-logo-image`} />
    {!compact && <span className="brand-subtitle" data-testid={`${location}-brand-logo-subtitle`}>Bar · Café</span>}
  </Link>
);